import classNames from "classnames";
import styles from "../styles/login.module.scss";
import {observer} from "mobx-react";
import {shareState} from "../../../app/share-state";
import {useEffect, useRef} from "react";

export const LoginWidgetPromoRegulation = observer(({controller}) => {
  const {state: {userAgreementForPrizesValue}} = controller;
  const ref = useRef();

  const checkboxProps = {
    type: "checkbox",
    checked: userAgreementForPrizesValue,
    className: classNames(styles.checkbox),
    onChange: (e) => controller.setUserAgreementForPrizes(e.target.checked)
  }

  const onClick = (url) => {
    shareState.isWebView ? shareState.nativeFunctionsUtils.callFunction("openBrowser", {url}) : window.open(url);
  }

  useEffect(() => {
    const children = ref.current?.children;
    if (children) {
      const arr = [].slice.call(children);

      arr?.forEach((child) => child.onclick = () => onClick(child.dataset.url))
    }
  }, []);

  const promoRegulationProps = {
    className: classNames(styles.promo_regulation_text),
    dangerouslySetInnerHTML: {
      __html: shareState.termsUtils.terms.BOLAO_PROMO_REGULATION_ACCEPTION
        .replaceAll('<a', '<div')
        .replaceAll('</a>', '</div>')
        .replaceAll('href', 'data-url')
    },
    ref
  }

  return (
    <div className={classNames(styles.promo_regulation_container)}>
      <div className={classNames(styles.promo_regulation)}>
        <input {...checkboxProps}/>
        <div {...promoRegulationProps}/>
      </div>
    </div>
  )
});
